import Service from "../../AuthService";
const LeaveDay = {
    getLeaveDay(page) {
        return Service.get("/leave_day?page="+page);
    },
    getLeaveDayAll(){
      return Service.get("/leave_day_all");
    },
    showLeaveDay(id) {
        return Service.get("/leave_day/" + id);
    },
    updateLeaveDay(id, data) {
        return Service.put("/leave_day/" + id, data);
    },
    createLeaveDay(data) {
        return Service.post("/leave_day", data);
    },
    deleteLeaveDay(id) {
        return Service.delete("/leave_day/" + id);
    },
    searchLeaveDay(data){
        return Service.post("/leave_day_search",data);
    },
    getLeaveHour(){
        return Service.get('/leave_hour');
    }
};
export default LeaveDay;
